export const StaffAvatar = ({ s, size = 24, active = false }) => {
  const color = s?.color || "#0ea5e9";
  const initials = (s?.name || "?").split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  return (
    <span className="relative inline-flex shrink-0 rounded-full" style={{ width: size, height: size, boxShadow: `0 0 0 2px ${active ? "#111" : "#fff"}, 0 0 0 4px ${color}` }} data-testid="staff-avatar">
      {s?.photo_url
        ? <img src={s.photo_url} alt="" className="w-full h-full rounded-full object-cover" />
        : <span className="w-full h-full rounded-full flex items-center justify-center font-bold text-white" style={{ background: color, fontSize: Math.max(9, size * 0.42) }}>{initials}</span>}
    </span>
  );
};

export const StaffLegend = ({ staff, value, onChange, allLabel }) => (
  <div className="flex items-center gap-1.5 flex-wrap" data-testid="cal-staff-legend">
    <button onClick={() => onChange("all")} data-testid="cal-legend-all"
      className={`text-xs font-semibold px-2.5 py-1 rounded-full border transition-colors ${value === "all" ? "bg-gray-900 text-white border-gray-900" : "bg-white border-gray-200 text-gray-600 hover:border-gray-400"}`}>{allLabel}</button>
    {staff.map((s) => {
      const active = value === s.id;
      return (
        <button key={s.id} onClick={() => onChange(active ? "all" : s.id)} data-testid={`cal-legend-${s.id}`} title={s.name}
          className={`flex items-center gap-1.5 text-xs font-semibold pl-1 pr-2.5 py-0.5 rounded-full border transition-colors ${active ? "bg-gray-900 text-white border-gray-900" : "bg-white border-gray-200 text-gray-700 hover:border-gray-400"}`}>
          <StaffAvatar s={s} size={18} active={active} />
          <span className="max-w-[90px] truncate">{s.name}</span>
        </button>
      );
    })}
  </div>
);
